import { render, staticRenderFns } from "./baobian.vue?vue&type=template&id=9dd7f000"
import script from "./baobian.vue?vue&type=script&lang=js"
export * from "./baobian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports